var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navget_main"},[_c('img',{attrs:{"src":_vm.goImg
        ? _vm.themeStyleVs === 2
          ? _vm.blockClose
          : _vm.closeImg
        : _vm.themeStyleVs === 2
        ? _vm.blockBackImg
        : _vm.backImg},on:{"click":_vm.goBack}}),_vm._v(_vm._s(_vm.text)+" "),(_vm.shareImgShow && _vm.compareVersions( _vm.version , 9.68))?_c('img',{staticClass:"share_btn_box",attrs:{"src":_vm.themeStyleVs === 2 ? _vm.blackShare : _vm.shareBtn,"alt":""},on:{"click":_vm.shareFn}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }